import { world } from '../languages';
import personalizationConfig from '../constants/personalization-config';
import { AVAILABLE_WORLDS } from '../languages/constants';

export type HighlightConfig = {
    otherCategory: boolean;
    userSelected: boolean;
    personalizedCategoryTitle?: string;
    shortTitle?: string;
};

const PersonalizationUtil = {
    isHighlighted: (item: Material, user: User, filters: Filters, favoriteSubject?: number): HighlightConfig => {
        if (
            !PersonalizationUtil.showReco() ||
            !filters.subject?.length ||
            !Array.isArray(user.preferences) ||
            (user.details && !user.details.highlightRecommendedMaterials)
        ) {
            return { otherCategory: false, userSelected: false };
        }
        let isS = false;
        let isC = false;
        let isFU = false;
        let shortTitle = '';
        let title = '';
        let sId = null;
        let fId = null;

        for (let i = 0; i < user.preferences.length; i++) {
            const s = user.preferences[i];

            if (item.materialTopCategories && item.materialTopCategories.length) {
                for (let j = 0; j < item.materialTopCategories.length; j++) {
                    const mt = item.materialTopCategories[j];

                    if (mt.id === s.category_id) {
                        isS = true;
                        sId = s.category_id;
                    }

                    if (mt.id === 1876 && world === 'de') {
                        isFU = true;
                        fId = 1876;
                    }
                }
            }

            if (item.materialClassGrades && item.materialClassGrades.length) {
                for (let j = 0; j < item.materialClassGrades.length; j++) {
                    if (s.class_grade_ids.indexOf(item.materialClassGrades[j].id) >= 0) {
                        isC = true;
                        break;
                    }
                }
            }

            if (isS && isC && favoriteSubject === sId) {
                break;
            }

            if (isFU && favoriteSubject === fId) {
                break;
            }
        }

        if (isS && isC && favoriteSubject !== fId) {
            isFU = false;
        }

        const id = isS && isC && favoriteSubject !== fId ? sId : isFU ? fId : null;

        if (id) {
            const sub = filters.subject.filter((f) => f.id === id);

            if (sub.length) {
                shortTitle = sub[0].shortTitle;
                title = sub[0].title;
            }
        }

        return { otherCategory: isFU, personalizedCategoryTitle: title, shortTitle, userSelected: isS && isC };
    },

    showReco: (): boolean => personalizationConfig.toBeShownInWorlds.includes(world as AVAILABLE_WORLDS)
};

export default PersonalizationUtil;
